var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mr-4",attrs:{"disabled":_vm.disabled,"color":"success"},on:{"click":_vm.save}},[_vm._v(" "+_vm._s(_vm.$t('save'))+" ")]),_c('v-btn',{staticClass:"mr-4",attrs:{"color":"error"},on:{"click":_vm.cancel}},[_vm._v(" "+_vm._s(_vm.$t('cancel'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }